// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1p558","search":"Settings_search__2S8WC","filter":"Settings_filter__28u8B"};